

export const MapIcons = {
  Pins: {
    Home: "custom-home",
    Issue: "custom-issue",
    Resolved: "custom-resolved",
    Moving: "custom-moving",
    Person: "custom-person",
    Warehouse: "custom-warehouse",
  },
  Navigation: {
    Arrow: "nav-arrow",
    Car: "car-front"
  },
  Shapes: {
    Circle: "circle"
  },
  Common: {
    Station: "station"
  }
}


export const ActivityEnums = {
  Type: {
    None: 0,
    Text: 1,
    ReportState: 2,
    AssignedTask: 3,
    AcceptedTask: 4,
    RejectedTask: 5,
    TaskStarted: 6,
    TaskArrived: 7,
    TaskLoaded: 8,
    TaskCompleted: 9,
    TaskAcknowledged: 10,
    MissionDraftCreated: 11,
    MissionCreated: 12,
    MissionCompleted: 13,
    MissionCancelled: 14,
    MissionDeleted: 15,
    StoredObjectDelivered: 16,

    TaskArrivedDest: 17,
    TaskDeleted: 18,
    MissionPlaceholder4: 19,
    MissionPlaceholder5: 20,
    MissionPlaceholder6: 21,
    MissionPlaceholder7: 22,
    MissionPlaceholder8: 23,
    MissionPlaceholder9: 24,
    MissionRequestAccepted: 25,
    MissionRequestRejected: 26,
    MissionRequestSent: 27,
    MissionPlaceholder13: 28,
    MissionPlaceholder14: 29,
    MissionPlaceholder15: 30,
    DispatcherOnDuty: 31,
    MissionPlaceholder17: 32,
    MissionPlaceholder18: 33,
    MissionPlaceholder19: 34,
    MissionPlaceholder20: 35,

    InvoiceJournalCreated: 36,
    CashJournalCreated: 37,
    InvoiceQueued: 38,
    InvoiceReOpened: 39,
    PaymentRequested: 40,
    PaymentConfirmed: 41,
    OrdersSettled: 42,
    SettlementsApproved: 43,
    SettlementApproved: 44,


  },
  Category: {
    None: 0,
    Mission: 1,
    Billing: 2,
    Other: 3
  },
}

export const ActivityEnumsLists = {
  Category: [
    "None",
    "Mission",
    "Billing",
    "Other",
  ],
  Type: [
    "None",
    "Text",
    "ReportState",
    "AssignedTask",
    "AcceptedTask",
    "RejectedTask",
    "TaskStarted",
    "TaskArrived",
    "TaskLoaded",
    "TaskCompleted",
    "TaskAcknowledged",
    "MissionDraftCreated",
    "MissionCreated",
    "MissionCompleted",
    "MissionCancelled",
    "MissionDeleted",
    "StoredObjectDelivered",
    "TaskArrivedDest",
    "TaskDeleted",
    "MissionPlaceholder4",
    "MissionPlaceholder5",
    "MissionPlaceholder6",
    "MissionPlaceholder7",
    "MissionPlaceholder8",
    "MissionPlaceholder9",
    "MissionRequestAccepted",
    "MissionRequestRejected",
    "MissionRequestSent",
    "MissionPlaceholder13",
    "MissionPlaceholder14",
    "MissionPlaceholder15",
    "DispatcherOnDuty",
    "MissionPlaceholder17",
    "MissionPlaceholder18",
    "MissionPlaceholder19",
    "MissionPlaceholder20",

    "InvoiceJournalCreated",
    "CashJournalCreated",
    "InvoiceQueued",
    "InvoiceReOpened",
    "PaymentRequested",
    "PaymentConfirmed",
    "OrdersSettled",
    "SettlementsApproved",
    "SettlementApproved",

  ]
};

export const IntegrationEnums = {
  Service: {
    Unknown: 0,
    Tripletex: 1,
    Duett: 2,
    PowerOfficeGo: 3,
    Unimicro: 4,
    UnimicroSMB: 5,
    EikaRegnskap: 6,
    AzetsComplete: 7,
    DNBRegnskap: 8,
    SparebankenSor: 9,
    Sparebank1: 10,
    UnimicroDev: 11,
    TrackSys: 12,
    MapOn: 13,
  },
  Category: {
    Unknown: 0,
    Accounting: 1,
    FleetManagement: 2,
  }
};


export const IntegrationEnumsLists = {
  Service: [
    "Unknown",
    "Tripletex",
    "Duett",
    "PowerOfficeGo",
    "Unimicro",
    "UnimicroSMB",
    "EikaRegnskap",
    "AzetsComplete",
    "DNBRegnskap",
    "SparebankenSor",
    "Sparebank1",
    "UnimicroDev",
    "TrackSys",
    "MapOn"
  ],
  Category: [
    "Unknown",
    "Accounting",
    "FleetManagement",
  ],
};


export const ExportEnums = {
  ErrorCode: {
    Ok: 0,
    MissingDeductibleProductGroup: 10,
    MissingVatProductGroup: 11
  },
  ExportType: {
    Unknown: 0,
    CashJournal: 1,
    InvoiceJournal: 2,
  },
  CashExportFormats: {
    XL10: 0,
  },
  InvoiceExportFormats: {
    SO01: 0,
  }
};

export const ExportEnumsLists = {
  CashExportFormats: [
    "XL10"
  ],
  InvoiceExportFormats: [
    "SO01"
  ]
};

export const OrderEnums = {
  Currency: {
    None: 0,
    NOK: 1,
    USD: 2
  },
  PaymentMethod: {
    None: 0,
    Invoice: 1,
    MobilePaymentRequest: 2,
    Cash: 3,
    Card: 4,
    MobilePayment: 5
  },
  InvoiceState: {
    None: 0,
    Queued: 1,
    Pending: 2,
    Finished: 3
  },
  OrderState: {
    None: 0,
    Open: 1,
    Ready: 2,
    Invoiced: 3,
    PaymentRequested: 4,
    PaymentConfirmed: 5
  },
  MissionOrderState: {
    None: 0,
    Open: 1,
    Closed: 2
  }
}


export const OrderEnumsLists = {
  Currency: [
    "None",
    "NOK",
    "USD"
  ],
  PaymentMethod: [
    "None",
    "Invoice",
    "MobilePaymentRequest",
    "Cash",
    "Card",
    "MobilePayment"
  ],
  InvoiceState: [
    "None",
    "Queued",
    "Pending",
    "Finished",
  ],
  OrderState: [
    "None",
    "Open",
    "Ready",
    "Invoiced",
    "PaymentRequested",
    "PaymentConfirmed"
  ],
  MissionOrderState: [
    "None",
    "Open",
    "Closed"
  ]
}


export const TaskEnums = {
  State: {
    None: 0,
    Created: 1,
    Assigned: 2,
    Responded: 3,
    Started: 4,
    Arrived: 5,
    Loaded: 6,
    ArrivedDest: 7,
    Completed: 8,
    Acknowledged: 9
  },
  DriverAssignedState: {
    Unknown: 0,
    Pending: 1,
    Accepted: 2,
    Rejected: 3
  },
  Type: {
    None: 0,
    Salvage: 1,
    Storage: 2
  },
  PlanningType: {
    None: 0,
    Time: 1,
    Interval: 2,
  },
  Priority: {
    Low: 0,
    Normal: 1,
    High: 2,
  },
  EstimatedUrgency: {
    None: 0,
    Low: 1,
    Normal: 2,
    High: 3,
    Critical: 4
  },
  UrgencyReason: {
    None: 0,
    Active: 1,
    Completed: 2,
    DriverRejected: 3,
    DriverPendingAcceptance: 4,
    DriverLateToAccept: 5,
    DriverAccepted: 6,
    AsapTask: 7,
    DeadlineCritical: 8,
    DeadlineNear: 9,
    CanBeStarted: 10,
    CantBeStartedYet: 11,
    DeadlineExpired: 12,
  },
};

export const RouteEnums = {
  NavigationType: {
    Unknown: 0,
    FreeNavigation: 1,
    ToRoute: 2,
    InRoute: 3,
  }
}

export const TaskEnumsLists = {
  State: [
    "None",
    "Created",
    "Assigned",
    "Responded",
    "Started",
    "Arrived",
    "Loaded",
    "ArrivedDest",
    "Completed",
    "Acknowledged",
  ],
  DriverAssignedState: [
    "Unknown",
    "Pending",
    "Accepted",
    "Rejected"
  ],
  PlanningType: [
    "Time",
    "None",
    "Interval",
  ],
  Priority: [
    "Low",
    "Normal",
    "High"
  ],
  EstimatedUrgency: [
    "None",
    "Low",
    "Normal",
    "High",
    "Critical"
  ],
  UrgencyReason: [
    "None",
    "Active",
    "Completed",
    "DriverRejected",
    "DriverPendingAcceptance",
    "DriverLateToAccept",
    "DriverAccepted",
    "AsapTask",
    "DeadlineCritical",
    "DeadlineNear",
    "CanBeStarted",
    "CantBeStartedYet",
    "DeadlineExpired",
  ]
};

export const TollFeeEnums = {
  FeeType: {
    Unknown: 0,
    TollFee: 1,
    Ferry: 2,
  }
};

export const TollFeeEnumsLists = {
  FeeType: [
    "Unknown",
    "TollFee",
    "Ferry",
  ]
}


export const MissionRequestEnums = {
  SourceType: {
    Unknown: 0,
    Form: 1,
    StationToStation: 2,
  },
  ResponseState: {
    New: 0,
    Rejected: 1,
    Accepted: 2
  }
}

export const MissionRequestEnumLists = {
  Response: [
    "New",
    "Rejected",
    "Accepted",
  ],
  SourceType: [
    "Unknown",
    "Form",
    "StationToStation",
  ],
  ResponseState: [
    "New",
    "Rejected",
    "Accepted"
  ]
}

export const MissionEnums = {
  State: {
    None: 0,
    Draft: 1,
    Cancelled: 2,
    Created: 3,
    Completed: 4,
    Archived: 5
  },
  TargetType: {
    Unknown: 0,
    Car: 1,
    Boat: 2,
    Other: 3
  },
  StorageState: {
    None: 0,
    Stored: 1,
    Delivered: 2
  },
  Type: {
    Unknown: 0,
    Salvage: 1,
    Towing: 2,
    Other: 3
  },
  FuelType: {
    Unknown: 0,
    Petrol: 1,
    Diesel: 2,
    Electric: 3,
    Other: 4,
    PluginHybrid: 5
  },
  EmissionClass: {
    Unknown: 0,
    ZeroEmission: 1,
    PluginHybrid: 2,
    Diesel: 3,
    Petrol: 4,
    EuroVI: 5,
    EuroV: 6,
  }
}

export const MissionFormEnums = {
  FormType: {
    Unknown: 0,
    EasyForm: 1,
    AdvancedForm: 2,
  }
};

export const MissionFormEnumsLists = {
  FormType: [
    "Unknown",
    "EasyForm",
    "AdvancedForm"
  ]
};

export const MissionEnumsLists = {
  State: [
    "None",
    "Draft",
    "Cancelled",
    "Created",
    "Completed",
    "Archived"
  ],
  Type: [
    "Unknown",
    "Salvage",
    "Towing",
    "Other"
  ],
  FuelType: [
    "Unknown",
    "Petrol",
    "Diesel",
    "Electric",
    "Other",
    "PluginHybrid"
  ],
  EmissionClass: [
    "Unknown",
    "ZeroEmission",
    "PluginHybrid",
    "Diesel",
    "Petrol",
    "EuroVI",
    "EuroV",
  ],
  Cause: [
    "Unknown"
  ],
  TargetType: [
    "Unknown",
    "Car",
    "Boat",
    "Other"
  ],
  DriveTrain: [
    "Unknown",
    "FWD",
    "RWD",
    "AWD",
    "Other"
  ],
  LocationState: [
    "Unknown",
    "NoOneAtLocation",
    "InPlace",
    "PoliceWaiting",
    "Phone"
  ],
  Currency: [
    "Unknown",
    "NOK",
    "USD"
  ],
  CurrencyUnit: [
    "Unknown",
    "kr",
    "$"
  ],
  InsuranceState: [
    "Unknown",
    "NotOK",
    "OKWithDeviations",
    "OKAccordingToCustomer",
    "OK",
  ],
  InsuranceType: [
    "Unknown",
    "Liability",
    "PartialCasco",
    "Casco",
    "Other",
  ],
  DriverAssignedState: [
    "Unknown",
    "Pending",
    "Accepted",
    "Rejected",
  ],
  Default: 0
};

export const Roles = {
  GlobalAdmin: "global-admin",
  StationAdmin: "station-admin",
  Driver: "driver",
  Accountant: "accountant",
  Operator: "operator"
};

export const RoleIds = {
  GlobalAdmin: "rol_eqYkEsthAmG4BTv8",
  Operator: "rol_7Io4yhg0aPkLa8rM",
  StationAdmin: "rol_0vUS6IfcdOV9wGRs",
  Driver: "rol_kVta8OMTCvqzePdE",
  Accountant: "rol_P6JVFqQdluoq1ezw"
};

export const RoleMap = {
  "rol_7Io4yhg0aPkLa8rM": "operator",
  "rol_0vUS6IfcdOV9wGRs": "station-admin",
  "rol_kVta8OMTCvqzePdE": "driver",
  "rol_P6JVFqQdluoq1ezw": "accountant",
  "rol_eqYkEsthAmG4BTv8": "global-admin"
};


export const DRIVER_ROLE_ID = "rol_kVta8OMTCvqzePdE";

export const ROLES_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";